module.exports = {
      id: "clean-map-big-usage",
      viewBox: "0 0 1560 718",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#clean-map-big",
      toString: function () {
        return this.url;
      }
    }